const KEY = 'mellow.appearance';
const media = window.matchMedia('(prefers-color-scheme: dark)');

function read() {
    try {
        return localStorage.getItem(KEY);
    } catch {
        return null;
    }
}

function write(value) {
    try {
        localStorage.setItem(KEY, value);
    } catch {}
}

/**
 * Manages light / dark / system appearance by toggling the "dark" class on <html>.
 * The inline script emitted by @mellowStyles applies the same logic before first paint.
 *
 * With `fromServer` the appearance comes from the server (e.g. the user's profile) and the
 * browser's stored choice is ignored. Every change dispatches `mellow:appearance-change`
 * on document so the app can persist it.
 */
export function createAppearance(fallback = 'system', fromServer = false) {
    let current = fromServer ? fallback : null;
    const value = () => current ?? read() ?? fallback;

    const apply = () => {
        const appearance = value();
        const dark = appearance === 'dark' || (appearance === 'system' && media.matches);
        document.documentElement.classList.toggle('dark', dark);
        document.dispatchEvent(new CustomEvent('mellow:appearance', { detail: { appearance, dark } }));
    };

    media.addEventListener('change', apply);

    return {
        get value() {
            return value();
        },
        set value(appearance) {
            if (!['light', 'dark', 'system'].includes(appearance)) {
                throw new Error(`Mellow: unknown appearance "${appearance}".`);
            }
            if (fromServer) current = appearance;
            else write(appearance);
            apply();
            document.dispatchEvent(new CustomEvent('mellow:appearance-change', { detail: { appearance } }));
        },
        get dark() {
            return document.documentElement.classList.contains('dark');
        },
        apply,
    };
}
